module.exports = __webpack_public_path__ + "static/media/enisa.e07742aa.webp";